// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39BFT","rootNoMargin":"styles_rootNoMargin__1hw1U"};